import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        functionId: null,
        breadCrumb: [],
        menuList: [],
        userInfo: null
    },
    mutations: {
        updateMenuList: (state, menuList) => {
            state.menuList = [ ...menuList ];
        },
        updateBreadcrumb(state, breadCrumb){
            state.breadCrumb = [ ...breadCrumb ];
        },
        updateUserInfo(state, userInfo) {
            state.userInfo = userInfo
        }
    },
    getters: {
        getMenuList: state => {
            return state.menuList;
        },
        getBreadCrumb: state => {
            return state.breadCrumb;
        },
        getUserInfo: state => {
            return state.userInfo;
        }
    },
    actions: {
    },
    modules: {
    }
})
